import { Divider, Grid, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import {
  CostValues,
  MemberValues,
} from '../../../core-utils/helper-utils/summaryReportHelper';
import componentConstants from '../../../core-utils/messages/componentConstants';

export interface OverviewCardTooltipContentProps {
  type: 'cost' | 'member';
  overviewCard: React.JSX.Element;
  cohortCostValues?: CostValues;
  totalCostValues?: CostValues;
  cohortMemberValues?: MemberValues;
  totalMemberValues?: MemberValues;
  hideDetailedInfo?: boolean;
  customTitle?: React.JSX.Element;
}

const OverviewCardTooltipContent: React.FC<OverviewCardTooltipContentProps> = ({
  cohortCostValues,
  cohortMemberValues,
  totalCostValues,
  totalMemberValues,
  overviewCard,
  type,
  hideDetailedInfo,
  customTitle,
}) => {
  const { classes } = makeStyles()({
    tooltip: {
      maxWidth: 'fit-content',
      padding: '10px',
      width: 'fit-content',
      backgroundColor: patientAccessTheme.palette.grey[900],
      borderRadius: '4px',
      marginTop: '-24px',
    },
    item: {
      marginBottom: '6px',
    },
  })();

  const constants = componentConstants.ATOMS.OVERVIEW_CARD_TOOLTIP_COMPONENT;

  const commonTypographyProps = {
    fontSize: '12px',
    lineHeight: '20px',
    textColor: patientAccessTheme.palette.status.white,
  };

  const getLabelValueComponent = (label: string, value: string) => {
    return (
      <Grid
        container
        direction="row"
        className={classes.item}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid>
          <Typography {...commonTypographyProps} margin="0px 4px 0px 0px">
            {label}
          </Typography>
        </Grid>
        <Grid>
          <Typography {...commonTypographyProps} fontType="semiBold">
            {value}
          </Typography>
        </Grid>
      </Grid>
    );
  };
  const isCost = type === 'cost';

  const title = (
    <Grid
      container
      sx={{
        flexDirection: 'column',
      }}
    >
      {getLabelValueComponent(
        isCost ? constants.TOTAL : constants.MEMBERS,
        isCost
          ? `${cohortCostValues?.total} / ${totalCostValues?.total}`
          : `${cohortMemberValues?.members} / ${totalMemberValues?.members}`,
      )}
      {hideDetailedInfo ? (
        <></>
      ) : (
        <>
          <Grid>
            <Divider
              style={{
                backgroundColor: patientAccessTheme.palette.status.white,
                marginBottom: '6px',
              }}
            />
          </Grid>
          {getLabelValueComponent(
            isCost ? constants.MEDICAL : constants.EMPLOYEES,
            isCost
              ? `${cohortCostValues?.medical} / ${totalCostValues?.medical}`
              : `${cohortMemberValues?.employees} / ${totalMemberValues?.employees}`,
          )}
          {getLabelValueComponent(
            isCost ? constants.RX : constants.DEPENDENTS,
            isCost
              ? `${cohortCostValues?.rx} / ${totalCostValues?.rx}`
              : `${cohortMemberValues?.dependents} / ${totalMemberValues?.dependents}`,
          )}
        </>
      )}
    </Grid>
  );

  return (
    <>
      <Tooltip
        title={customTitle ? customTitle : title}
        classes={{ tooltip: classes.tooltip }}
        arrow
      >
        <div>{overviewCard}</div>
      </Tooltip>
    </>
  );
};

export default OverviewCardTooltipContent;
